// extracted by mini-css-extract-plugin
export default {"spinner-container":"SpinnerContainer_spinner-container__WZe9u"};